export const ROUTES = {
  HOME: () => "/",
  LOGIN: () => "/login",
  RESET_PASSWORD: () => "/reset-password",
  REQUEST_PASSWORD_RESET: () => "/request-password-reset",
  ACCEPT_INVITATION: () => "/accept-invitation",
  SIGNUP: () => "/signup",
  BENEFITS: () => "/benefits",
  BUSINESSES: () => "/businesses",
  SETTINGS: () => "/settings",
  BENEFITS_NEW: () => "/benefits/new",
  BENEFITS_ID: () => "/benefits/:id",
  BUSINESSES_NEW: () => "/businesses/new",
  BUSINESSES_ID: () => "/businesses/:id",
  TRANSACTIONS: () => "/transactions",
  INSIGHTS: () => "/insights",
  TERMS_OF_SERVICE: () => "/terms-of-service",
  BILLING: () => "/billing",
  ADMIN_HOME: () => "/admin",
  ADMIN_TRANSACTIONS: () => "/admin-transactions",
  ADMIN_APP_PERFORMANCE: () => "/admin-app-performance",
  ADMIN_TOP_MERCHANTS: () => "/admin-top-merchants",
  ADMIN_CUSTOMER_BRACKETS: () => "/admin-customer-brackets",
  ADMIN_ERASURES: () => "/admin-erasures",
  ADMIN_ANALYTICS_PLUS: () => "/admin-activity",
  ADMIN_ACTIVITY_SEARCH: () => "/admin-activity/search",
  ADMIN_ACTIVITY_CLICKS: () => "/admin-activity/clicks",
  ADMIN_ZERO_RESULT_SUGGESTIONS: () => "/admin-zero-result-suggestions",
  ADMIN_KPI_REPORT: () => "/admin-kpi-report",
  ADMIN_KPI_REPORT_V2: () => "/admin-kpi-report-v2",
  ADMIN_REVENUE_SHARING: () => "/admin-revenue-sharing",
  ADMIN_MANAGEMENT: () => "/admin-management",
  ADMIN_SEARCH_PREVIEW: () => "/admin-search-preview",
  ADMIN_PARTNER_MANAGEMENT: () => "/admin-partner-management",
  ADMIN_PARTNER_NETWORK_REPORT: () => "/admin-partner-network-report",
  ADMIN_PARTNER_APPLICATION_DETAILS: (id?: string) =>
    id ? `/admin-partner-application/${id}` : "/admin-partner-application/:id",
  ADMIN_PARTNER_DETAILS: (id?: string) =>
    id ? `/admin-partner/${id}` : "/admin-partner/:id",
  ADMIN_VISA: () => "/admin-visa",
  ADMIN_VISA_TRANSACTION: () => "/admin-visa-transaction",
  ADMIN_FAILED_TRANSACTIONS: () => "/admin-failed-transactions",
  ADMIN_USERS: () => "/admin-users",
  ADMIN_CASHBACK_REQUESTS: () => "/admin-cashback-requests",
  ADMIN_INVOICING: () => "/admin-invoicing",
  ADMIN_WEBSHOP: () => "/admin-webshop",
  ADMIN_NOTIFICATIONS: () => "/admin-notifications",
  ADMIN_COMMUNICATION: () => "/admin-communication",
  ADMIN_SPECIAL_PARTNERS: () => "/admin-special-partners",
  ADMIN_PROMO_CODES: () => "/admin-promo-codes",
  ADMIN_OPT_IN_OFFERS: () => "/admin-opt-in-offers",
  ADMIN_FEATURED_PARTNERS: () => "/admin-featured-partners",
  ADMIN_FEATURED_PARTNERS_EDIT: (id?: string) =>
    id ? `/admin-featured-partners/${id}` : "/admin-featured-partners/:id",
  ADMIN_POPUP_CAMPAIGNS: () => "/admin-popup-campaigns",
  ADMIN_POPUP_CAMPAIGN_EDIT: (id?: string) =>
    id ? `/admin-popup-campaigns/${id}` : "/admin-popup-campaigns/:id",
  PROMOTIONS: () => "/promotions",
  PROMOTIONS_DRAFT_EDIT: (id?: string) =>
    id ? `/promotions/draft/${id}` : "/promotions/draft/:id",
  UPGRADE_MARKETING_PACKAGE: () => "/upgrade-marketing-package",
};
